import * as sortDirections from '../utils/sortDirections';
import {
  dsaTypeFilters,
  dsaStatusFilters
} from '../constants/dsaFilters';
import * as splunkLearningLinks from '../constants/splunkLearningLinks';

export default {

  strings: {
    signIn: 'Sign In',
    signOut: 'Sign Out',
    feedback: 'Share Feedback',
    help: 'Get Help',
    faq: 'FAQ',
    whatsNew: 'What\'s New',
    loadingText: 'Loading...',
    copyright: `2005-${new Date().getFullYear()} Splunk Inc. All rights reserved.`,
    lipsum: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.',
    splunkLearning: 'Splunk Learning',
    splunkLearningLink: splunkLearningLinks.SPLUNK_LEARNING_OVERVIEW
  },

  user: {
    logged_in: false,
    first_name: '',
    last_name: '',
    email: '',
    loading: true
  },

  dsa: {
    loading: true,
    loadingNew: false,
    processing: false,
    trainingSnackBar: {
      maybeShow: true
    }
  },

  createDSAWorkflow: {
    open: false
  },

  pptx: {
    generating: false,
    url: undefined
  },

  opportunities: {
    loading: false
  },

  dsaConfig: {},

  account: {
    data: {
      dsas: [],
      ivas: [],
      pvps: []
    },
    loading: true,
    dsaSort: {
      by: 'updatedAt',
      direction: sortDirections.DESC
    },
    dsaTypeFilter: dsaTypeFilters[0],
    dsaStatusFilter: dsaStatusFilters[0]
  },

  // rollups for current dsa, used by various front-end components, (derived from whatever data we end up with)
  stats: {

    goals: {
      total: {
        area: {
          1: 7,
          2: 7,
          3: 8,
          4: 5,
          5: 5
        }
      },
      count: {
        area: {
          1: 3,
          2: 7,
          3: 8,
          4: 3,
          5: 0
        }
      }
    },

    data: {
      total: {
        area: {
          1: 15,
          2: 36,
          3: 19,
          4: 7,
          5: 70
        }
      },
      count: {
        area: {
          1: 10,
          2: 36,
          3: 19,
          4: 2,
          5: 0
        }
      },
      gbPerDay: {
        area: {
          1: 2456,
          2: 2456,
          3: 2456,
          4: 2456,
          5: 2456
        }
      }
    }
  },

  xlsImports: {
    modalOpen: false,
    importing: false,
    importResults: {},
    importErrors: []
  },

  savingUpdatesText: ''
};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js